import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./style/index.css";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import { store, persistor } from "./reduxstore";
import { PersistGate } from "redux-persist/integration/react";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();

// <ReactReduxFirebaseProvider {...rrfProps}></ReactReduxFirebaseProvider>



// WEBPACK FOOTER //
// ./src/index.tsx